import styled from "styled-components";

export const colors = {
  white: "#ffffff",
  gold: "#c9a227",
  black: "#0b0b0b",
  line: "rgba(0,0,0,0.08)",
};

/* CARD PRINCIPAL */
export const ContactCard = styled.div`
  position: relative;
  background: ${colors.white};
  border-radius: 24px;
  padding: 10px 10px 8px;
  max-width: 760px;
  margin: 0 auto;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.15);

  /* border interior elegant */
  &::after {
    content: "";
    position: absolute;
    inset: 8px;
    border-radius: 18px;
    border: 1px solid rgba(201, 162, 39, 0.45);
    pointer-events: none;
  }
`;

/* HEADER */
export const Header = styled.div`
  text-align: center;
  padding: 34px 30px 12px;
`;

export const Ribbon = styled.div`
  width: 46px;
  height: 46px;
  border-radius: 999px;
  margin: -40px auto 14px;
  background: #fff;
  box-shadow: 0 0 0 2px ${colors.gold};
`;

export const Subtitle = styled.div`
  font-style: italic;
  color: ${colors.gold};
  font-size: 16px;
`;

export const Title = styled.h3`
  margin: 8px 0 6px;
  font-size: 30px;
  font-family: Georgia, serif;
  font-weight: 700;
  color: ${colors.black};
`;

export const OrnDivider = styled.div`
  height: 1px;
  width: 260px;
  margin: 12px auto 20px;
  background: linear-gradient(90deg, transparent, ${colors.gold}, transparent);
`;

/* FORM */
export const Form = styled.form`
  padding: 0 32px 30px;
`;

export const Row = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
  margin-bottom: 14px;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

export const Field = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Label = styled.label`
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.3px;
  color: #fc9ac4;
  margin-bottom: 6px;
  text-transform: uppercase;
`;

const baseInput = `
  border-radius: 16px;
  border: 1px solid ${colors.line};
  padding: 14px 16px;
  font-size: 16px;
  background: #f6f6f6;
  outline: none;
  transition: all .2s ease;

  &:focus {
    border-color: ${colors.gold};
    box-shadow: 0 0 0 3px rgba(201,162,39,0.15);
    background: #fff;
  }
`;

export const Input = styled.input`
  ${baseInput}
`;

export const Textarea = styled.textarea`
  ${baseInput}
  min-height: 140px;
  resize: vertical;
`;

export const Actions = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 16px;
`;

export const SubmitBtn = styled.button`
  background: ${colors.gold};
  color: #fff;
  border: none;
  padding: 14px 28px;
  border-radius: 999px;
  font-weight: 700;
  font-size: 16px;
  cursor: pointer;
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.15);
  transition: all 0.2s ease;

  &:hover {
    transform: translateY(-2px);
    filter: brightness(0.95);
  }
`;

export const ErrorMsg = styled.div`
  color: #c02b2b;
  font-size: 13px;
  margin-top: 4px;
`;

export const SuccessMsg = styled.div`
  margin-top: 14px;
  text-align: center;
  color: #2f7a3e;
`;

export const Helper = styled.div`
  font-size: 12px;
  color: rgba(0, 0, 0, 0.6);
  margin-top: 6px;
`;
